// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3c1e17d2","239":"7d966ac7","455":"01cae0db","531":"d367a755"}[chunkId] + ".chunk.js";
};